import React, { Fragment, useEffect, useMemo, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
//impoertacion componentes

import {
  creaInstitucion,
  obtenerDepartamento,
  obtenerMunicipio,
  obtenerTipoInstitucion,
} from "../../Services/Rest";
import Cookie from "universal-cookie";
import MaterialReactTable from "material-react-table";

function PriorizaIndicador() {
  const cookie = new Cookie();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [selectedOptions1, setSelectedOptions1] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtieneListadoIndicadores",
    })
      .then((Response) => {
        const apiOptions1 = Response.data.map((item) => ({
          value: item.codigo,
          label: item.nombreIndicador + item.codigo,
        }));
        setOptions1(apiOptions1);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  for (let i = 0; i < selectedOptions1.length; i++) {
    console.log(selectedOptions1[i].value);
  }
  const postData = (e) => {
    for (let i = 0; i < selectedOptions1.length; i++) {
      e.preventDefault(e);
      axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },

        url:
          "https://suadesarrollo.azurewebsites.net/api/PriorizaIndicadoresA/1055/" +
          selectedOptions1[i].value,
      })
        .then((Response) => {
          console.log(Response.data);
          window.location.reload("/");
          alert(Response.data);
        })
        .catch((error) => {
          console.log(error);
          alert("Error al crear" + error);
        });
    }
  };
  const grupos = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"];
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
      },
      {
        accessorKey: "grupo",
        header: "Grupo",
        filterVariant: "multi-select",
        filterSelectOptions: grupos,
      },
      {
        accessorKey: "nombreIndicador",
        header: "Nombre del Indicador",
        filterVariant: "text",
      },
      {
        accessorKey: "codigo",
        header: "Codigo Unico",
        filterVariant: "text",
      },
      {
        accessorKey: "lista",
        header: "Nivel Desagregacion",
        filterVariant: "text",
      },
      {
        accessorKey: "aplicabilidad",
        header: "Aplicabilidad",
        filterVariant: "text",
      },
      {
        accessorKey: "estadoInformacion",
        header: "Estado Información",
        filterVariant: "text",
      },
      {
        accessorKey: "unidadMedicion",
        header: "Unidad de medicón",
        filterVariant: "text",
      },
      {
        accessorKey: "numerador",
        header: "Numerador",
        filterVariant: "text",
      },
      {
        accessorKey: "denominador",
        header: "Denominador",
        filterVariant: "text",
      },

      {
        accessorKey: "resultado",
        header: "Resultado",
        filterVariant: "text",
      },
      {
        accessorKey: "mesCorte",
        header: "Mes Corte",
        filterVariant: "text",
      },
      {
        accessorKey: "institucionId",
        header: "Nombre de la institución",
        filterVariant: "text",
      },
      {
        accessorKey: "sedeId",
        header: "Sede",
        filterVariant: "text",
      },
      {
        accessorKey: "trimestre",
        header: "Año",
        filterVariant: "range",
        filterFn: "betweenInclusive", // use betweenInclusive instead of between
      },
      {
        accessorKey: "observaciones",
        header: "Observaciones",
        filterVariant: "text",
      },
    ],
    [],
  );
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerPriorizados/1055",
    })
      .then((Response) => {
        setList1(Response.data);
        const primerJson = Response.data[0];
        console.log("aaaaaaaaaaaa" + primerJson);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [tableData, setTableData] = useState(() => list1);

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    //if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    tableData[row.index] = values;
    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
  };
  const [rowSelection, setRowSelection] = useState([]);
  return (
    <div className="test">
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Priorizar indicadores
                </h6>
                <div className="col-sm-12">Seleccione el indicador</div>
                <Select
                  name="colors"
                  options={options1}
                  classNamePrefix="select"
                  isMulti
                  onChange={(selected) => setSelectedOptions1(selected)}
                />
                <br></br>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <form className="user">
                    <div className="form-group row"></div>

                    <a></a>
                    <hr />
                  </form>
                </div>
                <button
                  className="btn btn-primary btn-user btn-block "
                  onClick={postData}
                >
                  Guardar
                </button>
              </div>
            </div>
            <MaterialReactTable
              columns={columns}
              data={list1}
              enableMultiRowSelection={true}
              editingMode="modal"
              enableColumnOrdering
              onEditingRowSave={"handleSaveRowEdits"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default PriorizaIndicador;
